import { WidthType } from "components/components/Tabs/Tabs/Tabs";
import styled from "styled-components";
import colours from "styles/colours";

export const TabListContainer = styled.div<{ $widthType: WidthType }>`
  max-width: ${({ $widthType }): string => {
    switch ($widthType) {
      case WidthType.Wide:
        return "";
      case WidthType.SemiWide:
        return "1000px";
      case WidthType.NotWide:
        return "500px";
      default:
        return "1000px";
    }
  }};
`;

export const OldTabList = styled.div`
  display: flex;
  justify-content: space-between;
  margin: -1px;

  li + li {
    margin: 0;
  }
`;

export const TabList = styled.div`
  display: flex;
  background: ${colours.white};
  li + li {
    margin: 0;
  }
`;
